import { render, staticRenderFns } from "./Tenders.vue?vue&type=template&id=fdeb8b7e&scoped=true"
import script from "./Tenders.vue?vue&type=script&lang=js"
export * from "./Tenders.vue?vue&type=script&lang=js"
import style0 from "./Tenders.vue?vue&type=style&index=0&id=fdeb8b7e&prod&lang=scss&scoped=true"
import style1 from "./Tenders.vue?vue&type=style&index=1&id=fdeb8b7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdeb8b7e",
  null
  
)

export default component.exports